import { CoreText } from './Core/CoreText';
import { withStyles } from './Core/withStyles';

export const Text = withStyles(CoreText, {noSwitch: true, type: 'Text'});
